import { IPagination } from 'next-common';
import { IDropdownOption } from 'types';
import { orderBy } from 'lodash';
import {
  IDynamicListColumn,
  IDynamicListConfig,
  IDynamicListContentCount,
  IDynamicListProps,
  IDynamicListSort,
} from 'types';

export const getSortOptions = (cols: IDynamicListColumn[]): IDropdownOption<any>[] => {
  const filtered = cols.filter((x) => !x.noSort && (!x.order || x.order.xs >= 0));
  return filtered.map((x) => ({ label: x.header, value: x.key }));
};

export const formatted = (x: IDynamicListColumn, value: any, rowData: any) => {
  return x?.formatter?.(value, rowData) ?? value;
};

export const filterAndOrderCols = (cols: IDynamicListColumn[], orderKey: string = 'smUp'): IDynamicListColumn[] => {
  return orderBy(
    cols.filter((x: IDynamicListColumn) => !x.order || x?.order?.[orderKey] >= 0),
    `order.${orderKey}`
  );
};

const defaultConfig = (data: any[]): IDynamicListConfig => ({
  cols: !data || data.length === 0 ? [] : Object.keys(data[0]).map((key) => ({ key, header: key })),
  noHeader: false,
  selectable: true,
  maxSelected: 1,
  withAccordion: false,
  sortingIcon: {},
});

export const getConfig = (props: IDynamicListProps): IDynamicListConfig => {
  return {
    ...defaultConfig(props.data),
    ...props.config,
  };
};

export const sortItems = (data: any[], sort: IDynamicListSort[]): any[] => {
  return orderBy(
    data,
    sort?.map((x) => x.key),
    sort?.map((x) => (x.reverse ? 'desc' : 'asc'))
  );
};

export const createContentCount = (totalListSize: number, pagination: IPagination): IDynamicListContentCount => {
  const showCount = pagination.itemsPerPage * pagination.page;

  return {
    totalNumber: totalListSize,
    showingNumber: Math.min(pagination.page * pagination.itemsPerPage, showCount),
  };
};

export const noToShow = (pagination: IPagination) => {
  return pagination?.itemsPerPage * pagination?.page;
};
